import * as types from '@/store/statistics/actionTypes';
// eslint-disable-next-line import/no-cycle
import {
  calculateDashboardStatistics,
  calculateProjectsStatistics,
  getPassiveRiskScore,
  calculateCloudServicesStatistics, recalculateRiskScore,
} from '@/services/repository';
import {
  CLEAR_PASSIVE_RISK_SCORE,
  SET_CLOUD_SERVICES_STATISTICS,
  SET_GENERAL_STATISTICS,
  SET_PASSIVE_RISK_SCORE,
  SET_PROJECT_STATISTICS, SET_RECALCULATION_IN_PROGRESS,
} from '@/store/statistics/mutationTypes';
import { LOAD_PASSIVE_RISK_SCORE } from '@/store/statistics/actionTypes';

export default {
  async [types.LOAD_GENERAL_STATISTICS]({ commit }, filters) {
    const generalStatistics = await calculateDashboardStatistics(filters);
    commit(SET_GENERAL_STATISTICS, generalStatistics);
  },
  async [types.LOAD_PROJECT_STATISTICS]({ commit }, filters) {
    const projectStatistics = await calculateProjectsStatistics(filters);
    commit(SET_PROJECT_STATISTICS, projectStatistics);
  },
  // eslint-disable-next-line no-unused-vars
  async [types.LOAD_PASSIVE_RISK_SCORE]({ commit, getters }, tlds) {
    const riskScore = await getPassiveRiskScore(tlds);
    commit(SET_PASSIVE_RISK_SCORE, riskScore);
  },
  async [types.RESET_PASSIVE_RISK_SCORE]({ commit }) {
    commit(CLEAR_PASSIVE_RISK_SCORE);
  },
  async [types.LOAD_CLOUD_SERVICES_STATISTICS]({ commit }, filters) {
    const cloudServicesStatistics = await calculateCloudServicesStatistics(filters);
    commit(SET_CLOUD_SERVICES_STATISTICS, cloudServicesStatistics);
  },
  async [types.RECALCULATE_RISK_SCORE]({ dispatch, commit, getters }, tlds) {
    let currentRecalculationInProgress = Array.from(new Set([...getters.recalculationInProgress, ...tlds]));
    await commit(SET_RECALCULATION_IN_PROGRESS, currentRecalculationInProgress);
    try {
      await recalculateRiskScore(tlds);
      await dispatch(LOAD_PASSIVE_RISK_SCORE, { domain: tlds });
    } catch (e) {
      console.error(e);
    } finally {
      currentRecalculationInProgress = currentRecalculationInProgress.filter(tld => !tlds.includes(tld));
      await commit(SET_RECALCULATION_IN_PROGRESS, currentRecalculationInProgress);
    }
  },
  // eslint-disable-next-line no-unused-vars
  async [types.RECALCULATE_RISK_SCORE_BULK]({ dispatch }, tlds) {
    await recalculateRiskScore(tlds);
  },
};
